import { Box } from "@mui/material";
import { useIsBehindFeatureFlag } from "hooks/useFeatureFlag";
import { useStringQueryParamState } from "hooks/useStringQueryParamState";
import { ToggleSelector } from "../ToggleSelector";
import { BucketChargeComplianceTable } from "./BucketChargeComplianceTable";
import { HeatComplianceTable } from "./HeatComplianceTable";
import { OutlierHeatsRegion } from "./OutlierHeatsRegion";
import { RankingComplianceDiffTable } from "./RankingComplianceDiffTable";
import {
  COMPLIANCE_DATE_RANGE_CONFIG,
  DateRangeProvider,
} from "contexts/DateRangeContext";

type ComplianceViewMode = "summary" | "byHeat";

export const ComplianceTab = () => {
  const hasRankingComplianceTab = useIsBehindFeatureFlag(
    "ranking_compliance_tab"
  );
  const hasCompliancePerHeat = useIsBehindFeatureFlag("compliance_per_heat");

  if (hasRankingComplianceTab && hasCompliancePerHeat) {
    return (
      <DateRangeProvider config={COMPLIANCE_DATE_RANGE_CONFIG}>
        <RankingWithPerHeatToggle />
      </DateRangeProvider>
    );
  }

  if (hasRankingComplianceTab) {
    return (
      <DateRangeProvider config={COMPLIANCE_DATE_RANGE_CONFIG}>
        <OutlierHeatsRegion>
          <RankingComplianceDiffTable />
        </OutlierHeatsRegion>
      </DateRangeProvider>
    );
  }

  return (
    <DateRangeProvider config={COMPLIANCE_DATE_RANGE_CONFIG}>
      <OutlierHeatsRegion>
        <BucketChargeComplianceTable />
      </OutlierHeatsRegion>
    </DateRangeProvider>
  );
};

const RankingWithPerHeatToggle = () => {
  const [viewMode, setViewMode] = useStringQueryParamState<ComplianceViewMode>(
    "complianceView",
    "summary"
  );

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ mb: 2, pt: 1 }}>
        <ToggleSelector<ComplianceViewMode>
          selectedValue={viewMode}
          setSelectedValue={setViewMode}
          availableValueLabels={{ summary: "summary", byHeat: "byHeat" }}
        />
      </Box>
      {viewMode === "summary" ? (
        <OutlierHeatsRegion sx={{ pt: 1 }}>
          <RankingComplianceDiffTable />
        </OutlierHeatsRegion>
      ) : (
        <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
          <HeatComplianceTable />
        </Box>
      )}
    </Box>
  );
};
